import { Button, Step, StepLabel, Stepper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ZOOM_LOGIN_REDIRECT_PATH } from '../config/apiPaths';
import logo from '../images/class-logo-full-color-rgb-313px@72ppi.png';
import zoomPermissionsExample from '../images/zoom-auth-permissions-example.png';
import { ensureUserUuid } from '../utils/ensureUserUuid';
import { getUrls } from '../utils/url';

const StyledHeader = styled.div`
    margin: 10px;
    display: flex;
    align-items: flex-end;
`;

const StyledLogo = styled.img`
    width: 151px;
`;

const StyledScreenshot = styled.img`
    width: 879px;
    margin: 10px auto;
`;

const StyledStepperDiv = styled.div`
    margin: 34px auto 0px auto;
`;

const StyledTitle = styled(Typography)`
    margin-left: 26px;

    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
`;

const StyledMainDiv = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0px 41px;
`;

const StyledGrantPermissonText = styled(Typography)`
    margin-top: 26px;
`;

const StyledLaunchButton = styled(Button)`
    margin: 10px auto 0px 0px;
`;

const StyledContentDiv = styled.div`
    margin: 10px;
`;

const ZoomAuthRedirect = () => {
    const { ready, t } = useTranslation('zoom_auth');
    const search = new URLSearchParams(window.location.search);

    const title = search.get('title');
    const email = search.get('email');
    const username = search.get('username');
    const role = search.get('role');

    const { api } = getUrls();

    const redirectToZoomLogin = () => {
        const userUuid = ensureUserUuid();
        const state = {
            target: 'react/zoom-auth-success',
            user_uuid: userUuid,
            email,
            username,
            role
        };
        const redirectUrl = `${api}${ZOOM_LOGIN_REDIRECT_PATH}?state=${JSON.stringify(state)}&output=embed`;
        window.open(encodeURI(redirectUrl), '_blank');
    };

    const Header = () => (
        <StyledHeader>
            <StyledLogo src={logo}/>
            <StyledTitle>
                {title}
            </StyledTitle>
        </StyledHeader>
    );

    const ZoomPermissionsStepper = () => {
        const stepInfo: any[] = [];
        for (let i = 0; i < 3; i++) {
            stepInfo.push({
                title: t(`step-${i + 1}-title`),
                description: t(`step-${i + 1}-description`)
            });
        }
        return (
            <StyledStepperDiv>
                <Stepper activeStep={3}>
                    {stepInfo.map((step, index) => (
                        <Step key={index}>
                            <StepLabel optional={<Typography variant='caption'>{step.description}</Typography>}>{step.title}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </StyledStepperDiv>
        );
    };

    if (ready) {
        return (
            <StyledMainDiv>
                <Header/>
                <StyledContentDiv>
                    <StyledGrantPermissonText>{t('grant-permission-info')}</StyledGrantPermissonText>
                    <ZoomPermissionsStepper/>
                    <StyledLaunchButton variant='contained' onClick={redirectToZoomLogin}>{t('open-zoom-permissions')}</StyledLaunchButton>
                </StyledContentDiv>
                <StyledScreenshot src={zoomPermissionsExample}/>
            </StyledMainDiv>
        );
    }

    return <></>;
};

export default ZoomAuthRedirect;
